exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menu-images-text-1{fill:#f1faf9}.menu-images-text-2{fill:#f9fbfc}.menu-images-text-3{fill:#1e4e69}.menu-images-text-4{fill:#ee7470}.menu-images-text-5{fill:#fff}.menu-images-text-6{fill:#1d435e}.menu-images-text-7{fill:#73cac2}\n", ""]);
